export default "__VITE_ASSET__69db6798__"